import React from 'react';
import "./dash.css"
import Image from './IMG_20200221_102241.png'
function Dashboard() {
        return (
            <div class='dashboard'>
                <h1 class='animate'></h1>
                <h1 class='red-text animate1'></h1>
                <h1 class='red-text animate2'></h1>

            </div>
        );
}


export default Dashboard;
